/**
 * Утилита для управления согласием на использование куки
 */

const COOKIE_CONSENT_KEY = 'cookieConsent';
const COOKIE_BANNER_LAST_SHOWN_KEY = 'cookieBannerLastShown';

/**
 * Получить текущую дату в формате YYYY-MM-DD
 */
export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Проверить, нужно ли показывать плашку с куки
 * Плашка показывается 1 раз в день
 */
export const shouldShowCookieBanner = () => {
  // Проверяем, есть ли уже согласие
  const consent = getCookieConsent();
  if (consent && consent.accepted) {
    return false;
  }

  // Проверяем, показывалась ли плашка сегодня
  const lastShown = localStorage.getItem(COOKIE_BANNER_LAST_SHOWN_KEY);
  const today = getCurrentDate();

  if (lastShown === today) {
    // Уже показывалась сегодня
    return false;
  }

  return true;
};

/**
 * Сохранить дату последнего показа плашки
 */
export const saveBannerLastShown = () => {
  const today = getCurrentDate();
  localStorage.setItem(COOKIE_BANNER_LAST_SHOWN_KEY, today);
};

/**
 * Получить согласие на куки из localStorage
 */
export const getCookieConsent = () => {
  try {
    const consentStr = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consentStr) {
      return null;
    }
    return JSON.parse(consentStr);
  } catch (error) {
    console.error('Ошибка при чтении согласия на куки:', error);
    return null;
  }
};

/**
 * Сохранить согласие на куки в localStorage
 */
export const saveCookieConsent = (accepted = true) => {
  try {
    const consent = {
      accepted,
      timestamp: Date.now(),
      version: '1.0'
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    return true;
  } catch (error) {
    console.error('Ошибка при сохранении согласия на куки:', error);
    return false;
  }
};

/**
 * Проверить, дано ли согласие на использование куки
 */
export const hasCookieConsent = () => {
  const consent = getCookieConsent();
  return consent && consent.accepted === true;
};

/**
 * Сбросить согласие на куки (для тестирования)
 */
export const resetCookieConsent = () => {
  localStorage.removeItem(COOKIE_CONSENT_KEY);
  localStorage.removeItem(COOKIE_BANNER_LAST_SHOWN_KEY);
};
